import {Badge} from '@mantine/core';
import {ActionStatus} from '../types.ts';

const STATUS_CONFIG: Record<ActionStatus, { color: string, label: string }> = {
    [ActionStatus.DRAFT]: {
        color: 'gray',
        label: 'Draft'
    },
    [ActionStatus.ACTIVE]: {
        color: 'green',
        label: 'Active'
    },
    [ActionStatus.RETIRED]: {
        color: 'orange',
        label: 'Retired'
    },
};

export const ActionStatusBadge = ({status}: { status?: ActionStatus }) => {

    if (!status) {
        return <Badge color='dark'>Invalid Status</Badge>;
    }

    const config = STATUS_CONFIG[status];
    if (!config) {
        return <Badge color='dark'>{status}</Badge>;
    }

    return <Badge color={config.color}>{config.label}</Badge>;
};
